import React, { useEffect, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { ConfigProvider, DatePicker, Space } from "antd";
import moment from "moment";
import dayjs from "dayjs";

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 999,
  },
  container: {
    width: "40%",
    padding: "30px",
    paddingTop: '20px',
    borderRadius: "18px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontSize: "20px",
    fontWeight: "bold",
    textAlign: "left",
    marginBottom: "10px",
  },
  cancelIcon: {
    cursor: "pointer",
  },
  description: {
    textAlign: "left",
    fontSize: "16px",
    color: "#272728",
    marginTop: "10px",
  },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "12px",
    border: "1px solid #CCCCCC",
    marginBottom: "20px",
    boxSizing: "border-box",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    width: "180px",
    height: "45px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    marginRight: "10px",
    transition: "opacity 0.3s", // Smooth transition for opacity change
  },
  confirmButton: {
    backgroundColor: "primaryBlue",
    color: "#FFFFFF",
  },
  cancelButton: {
    backgroundColor: "#CCCCCC",
    color: "#000000",
  },
};
const ExportCasInOutReportModal = ({
  heading,
  isOpen,
  onClose,
  onExport,
  showFutureDates = false,
}) => {
  const [fields, setFields] = useState([]);
  const { t, i18n } = useTranslation();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const { RangePicker } = DatePicker;
  const formatDate = (date) => dayjs(date).format("YYYY-MM-DD");

  const handleRangePickerChange = (dates) => {
    if (dates) {
      //   setLoading(true);
      const startDate = formatDate(dates[0]);
      const endDate = formatDate(dates[1]);
      setStartDate(startDate);
      setEndDate(endDate);
      console.log(startDate, endDate);
    }
  };
  const disabledDate = (current) => {
    if (showFutureDates) return false;
    return current && current > moment().endOf("day");
  };

  return (
    isOpen && (
      <>
        <div
          className="backdrop-blur"
          style={styles.overlay}
          onClick={onClose}
        ></div>
        <div style={styles.container}>
          <div style={styles.header}>
            <p style={styles.title}>{heading}</p>
            <CloseOutlined style={styles.cancelIcon} onClick={onClose} />
          </div>
          <h2 className="text-base mb-2 italic text-gray-600 mt-3">
            {t("Select Date to Export")}
          </h2>
          <ConfigProvider direction={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
            <RangePicker
              className="w-full h-10 mt-2 range-picker-placeholder"
              style={{ minWidth: 220 }}
              onChange={handleRangePickerChange}
              placeholder={[t("Start Date"), t("End Date")]}
              disabledDate={disabledDate}

            />
          </ConfigProvider>
          {/* Action Buttons */}
          <div className="flex justify-end gap-4 mt-5 ">
            <button
              type="button"
              onClick={onClose}
              className="w-32 px-2 py-2 border border-gray-300 font-semibold rounded-lg text-gray-700 hover:bg-gray-50"
            >
              {t("Cancel")}
            </button>
            <button
              disabled={(startDate == '' || endDate == '')}
              onClick={() => {
                const dates = {
                  startDate: startDate,
                  endDate: endDate
                }
                onExport(dates)
              }}
              className={`w-32 px-2 py-2 rounded-lg font-semibold text-white ${(startDate == '' || endDate == '')
                ? "bg-primaryBlue opacity-50 cursor-not-allowed"
                : "bg-primaryBlue"
                }`}
            // className="w-full px-4 py-2 bg-primaryBlue text-white rounded-lg hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {t("Export")}
            </button>
          </div>
        </div>
      </>
    )
  );
};

export default ExportCasInOutReportModal;
